import { InputSwitch } from "primereact/inputswitch";
import React from "react";
import { useState } from "react";
import { putCustomerPackageOffer } from "../../../services/CustomerPackageOffer/CustomerPackageOffer";
import { Dropdown } from "primereact/dropdown";

const CustomerPackageStatusChange = ({
  status,
  editData,
  sendDataToCustomerPackage,
  brandId,
  storeId,
  storeCustomerId,
}) => {

  const activeNotificationList = [
    {
      name: "PROSPECTIVE",
      value: "PROSPECTIVE"
    },
    {
      name: "ACTIVE",
      value: "ACTIVE"
    },
    {
      name: "INACTIVE",
      value: "INACTIVE"
    },
    {
      name: "RUNNING",
      value: "RUNNING"
    },
    {
      name: "CONSUMED",
      value: "CONSUMED"
    }
  ];

  // const statusValue = status === "ACTIVE";
  const [activeNotification, setActiveNotification] = useState(status);

  const handleEditData = (NotificationValue) => {
    // Update the specific field in editCustomerData
    let updatedData = {
      status: NotificationValue,
      brandPackageOffer: {
        id: editData.brandPackageOffer.id,
      },
      storeCustomerId: storeCustomerId,
      id: editData.id,
    };
    putCustomerPackageOffer(brandId, storeId, updatedData)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          if (Res) {
            sendDataToCustomerPackage({
              success: true,
            });
          }
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
    setActiveNotification(NotificationValue);
  };

  return (

    <div

    >
      {/* <InputSwitch
          checked={activeNotification}
          onChange={(e) => handleEditData(e.value)}
        />*/}

      <Dropdown
        value={activeNotification}
        onChange={(e) => handleEditData(e.value)}
        options={activeNotificationList}
        placeholder="Status"
        optionLabel="name"
        className="w-full  bg-white-alpha-20 border-round-lg p-0 text-lg text-primary-50"
      />
    </div>

  );
};

export default CustomerPackageStatusChange;
